import { Box, styled, Tab, Tabs, Typography } from '@mui/material';
import { Colors } from '../../../layout/theme-next';

export const ChartContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const ChartScroll = styled('div')({
  position: 'relative',
  width: '350px',
  height: '130px',
});

export const Title = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '20px',
});

export const TabWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const TabLabel = styled('span')<{ inactive?: boolean }>(({ inactive }) => ({
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '20px',
  color: inactive ? Colors.textGray : Colors.textBlack,
}));

export const Dot = styled('span')<{ color: string }>(({ color }) => ({
  width: 10,
  height: 10,
  background: color,
  borderRadius: '50%',
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 30,
  '& .MuiTab-root': {
    minHeight: 30,
    padding: theme.spacing(0.5, 1),
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 30,
  minWidth: 'fit-content',
  width: 'fit-content',
  padding: theme.spacing(0.5, 1),
  textTransform: 'uppercase',
  fontSize: 14,
  flexShrink: 0,
}));
